import { render, staticRenderFns } from "./FileManagementList.vue?vue&type=template&id=088bf3f7"
import script from "./FileManagementList.vue?vue&type=script&lang=js"
export * from "./FileManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports